/**
 * BRAND — single source of truth for Foundry brand refs.
 *
 * All brand strings that appear in public surfaces (PDFs, share-cards,
 * emails, metadata, JSON-LD, RSS, sitemaps) MUST import from here instead
 * of hardcoding. Rebrand = edit one file.
 *
 * Rules:
 *   - Do NOT read environment vars here (keep BRAND deterministic & tree-
 *     shakeable). Runtime base URLs (overridable via NEXT_PUBLIC_BASE_URL)
 *     are resolved by callers — `BRAND.url` is the canonical production
 *     fallback, not the env override.
 *   - Scope: TS/TSX source only. package.json, migration SQL, deploy
 *     scripts, env defaults — intentionally NOT migrated (different stack).
 *   - Voice rules ("Brand subject = 'Foundry'" in prompts) stay in
 *     prompt files — they are prose, not refs.
 */

export const BRAND = {
  /** Display name. Used in siteName, JSON-LD Organization.name, PDF author/creator, email alt text. */
  name: "Foundry",

  /** Canonical production URL (https). */
  url: "https://foundrystart.com",

  /** Bare domain (no protocol). Used in PDF footers, share-card subtitles, deploy subdomains. */
  domain: "foundrystart.com",

  /** Short mission tagline — landing-v2 Finale & Organization description. */
  tagline: "Everyone has a niche.",

  /** Long-form description — metadata, OG, JSON-LD WebSite. */
  description:
    "Find your business niche. Four questions. Half an hour. Named, planned, waiting.",

  /** Ambient share-card/PDF footer pill. Lowercase canonical domain. */
  watermark: "foundrystart.com",

  /** Contact email (matches RESEND_FROM fallback + EmailLayout links). */
  email: "hello@foundrystart.com",

  /** Twitter/X handle (no @). */
  twitterHandle: "foundrystart",

  /** Instagram handle (no @). */
  instagramHandle: "foundrystart",
} as const;
